import { render, staticRenderFns } from "./ReturnDialog.vue?vue&type=template&id=8b726ada&scoped=true"
import script from "./ReturnDialog.vue?vue&type=script&lang=js"
export * from "./ReturnDialog.vue?vue&type=script&lang=js"
import style0 from "./ReturnDialog.vue?vue&type=style&index=0&id=8b726ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b726ada",
  null
  
)

export default component.exports